export default __webpack_public_path__ + "static/media/Belt of Concealing Shadows.d41d6784.jpg";